import React, { useState, useEffect } from "react";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import { Link } from "react-router-dom";
import { SidebarData } from "./SidebarData";
import "./navbar.component.css";
import { IconContext } from "react-icons";
import {
	BrowserRouter as Router,
	Routes,
	Route,
	NavLink,
	useParams,
} from "react-router-dom";
import {
	onAuthStateChanged,
	signInWithEmailAndPassword,
	signOut,
} from "firebase/auth";
import { auth } from "../firebase-config";

import HomeModule from "./modules/home.module";
import PlayersModule from "./modules/players.module";
import ProgramsModule from "./modules/programs.module";
import PaymentsModule from "./modules/payments.module";
import SupportModule from "./modules/support.module";
import UserModule from "./modules/user.module";
import ClubsModule from "./modules/clubs/clubs.module";
import Dialog from "./modules/Dialog";
import { Container, Nav, Navbar, NavbarBrand } from "react-bootstrap";
import NavbarCollapse from "react-bootstrap/esm/NavbarCollapse";
import Cookies from "universal-cookie";
import { db } from "../firebase-config";
import {
	collection,
	getDoc,
	getDocs,
	addDoc,
	updateDoc,
	deleteDoc,
	doc,
	Firestore,
	query,
	where,
} from "firebase/firestore";

const Menu = (props) => {
	const cookies = new Cookies();
	const [users, setUsers] = useState({});
	const [sidebar, setSidebar] = useState(false);
	const [userData, setUserdata] = useState(null);
	const usersCollectionRef = collection(db, "users");
	const [isLoadingmenu, setLoadingmenu] = useState(true);
	const [isLoading, setLoading] = useState(false);
	const [club_id, setClub_id] = useState("");
	const [club_name, setClub_name] = useState("");

	const getUserData = async (uid) => {
		if (props.user.uid != undefined) {
			const q = query(usersCollectionRef, where("id", "==", uid));
			const docSnap = await getDocs(q);
			docSnap.forEach((doc) => {
				// doc.data() is never undefined for query doc snapshots
				setUserdata(doc.data());
				cookies.set("uid_record", doc.id, { path: "/" });
				if (doc.data().main_user != "1") {
					document.getElementById("Programs").style.display = "none";
					document.getElementById("Clubs").style.display = "none";
					document.getElementById("Payments").style.display = "none";
				}
				setLoadingmenu(false);
				setClub_name(doc.data().club_name);
			});
		}
	};

	useEffect(() => {
		if (isLoadingmenu) {
			document.getElementById("dataMenu").style.display = "none";
			document.getElementById("loaderMenu").style.display = "block";
		} else {
			document.getElementById("dataMenu").style.display = "block";
			document.getElementById("loaderMenu").style.display = "none";
		}
	}, [isLoadingmenu]);

	const { type } = useParams();
	const showSidebar = () => {
		setSidebar(!sidebar);
	};

	useEffect(() => {
    if(window.innerWidth >= 600) setSidebar(true);
		onAuthStateChanged(auth, async (currentUser) => {
			setUsers(currentUser);
			getUserData(currentUser.uid);
		});
		// Notice the empty dependency array, there to make sure the effect is only run once when the component mounts
	}, []);

	const logout = async () => {
		await signOut(auth);
		window.location = "/";
	};

	// console.log(user)
	//CONFIRM
	const [dialog, setDialog] = useState({
		message: "",
		isLoading: false,
		//Update
		nameProduct: "",
	});

	const handleDialog = (message, isLoading, nameProduct) => {
		setDialog({
			message,
			isLoading,
			//Update
			nameProduct,
		});
	};

	const handleSignOut = () => {
		//Update
		handleDialog(
			"Are you sure you want to sign out?",
			true,
			cookies.get("email")
		);
	};

	const areUSureSignOut = (choose) => {
		if (choose) {
			logout();
			handleDialog("", false);
		} else {
			handleDialog("", false);
		}
	};
	return (
		<>
			<div id="dataMenu">
				<IconContext.Provider value={{ color: "#fff" }}>
					{/* HORIZONTAL */}
					<Navbar>
						<Link to="#" className="menu-bars">
							<FaIcons.FaBars onClick={showSidebar} />
						</Link>
						<NavbarBrand>
							<font color="white">
								<b>Sport</b> Campament
							</font>
						</NavbarBrand>
						<NavbarCollapse id="nav-collapse">
							<Nav className="me-auto"></Nav>
							<Nav>
								<Link className="padding-nav" to="/admin/clubs" href={"/clubs"}>
									<font color="white">
										Club: <b>{club_name}</b>
									</font>
								</Link>
								<Link className="padding-nav" to="/admin/user" href={"/user"}>
									<font color="white">
										Username:{" "}
										<b>{props.user.email != null ? props.user.email : ""}</b>
									</font>
								</Link>
								<Link
									className="padding-nav"
									to="#"
									href={"/#"}
									onClick={() => {
										handleSignOut();
									}}
								>
									<font color="white">Sign Out</font>
								</Link>
							</Nav>
						</NavbarCollapse>
					</Navbar>
					<div id="mainNest">
						<nav
							id="mySidenav"
							className={sidebar ? "nav-menu active" : "nav-menu"}
						>
							<ul className="nav-menu-items">
								{SidebarData.map((item, index) => {
									if (item.title === "Sign Out") {
										return (
											<li key={index} className={item.cName} id={item.title}>
												<Link
													to={item.path}
													onClick={() => {
														handleSignOut();
													}}
												>
													{item.icon}
													{sidebar == true ? <span>{item.title}</span> : ""}
												</Link>
											</li>
										);
									} else {
										return (
											<li key={index} className={item.cName} id={item.title}>
												<Link
													to={item.path}
													onClick={() => {
														if (window.innerWidth < 600) setSidebar(false);
													}}
												>
													{item.icon}
													{sidebar == true ? <span>{item.title}</span> : ""}
												</Link>
											</li>
										);
									}
								})}
							</ul>
						</nav>
						<main id="main" style={{ width: "100%" }}>
							{userData ? (
								<>
									{type == null && (
										<HomeModule userHome={props.user} userData={userData} />
									)}
									{type == "clubs" && (
										<ClubsModule userHome={props.user} userData={userData} />
									)}
									{type == "players" && (
										<PlayersModule userHome={props.user} userData={userData} />
									)}
									{type == "payments" && (
										<PaymentsModule userHome={props.user} userData={userData} />
									)}
									{type == "programs" && (
										<ProgramsModule userHome={props.user} userData={userData} />
									)}
									{type == "support" && (
										<SupportModule userHome={props.user} userData={userData} />
									)}
									{type == "user" && (
										<UserModule userHome={props.user} userData={userData} />
									)}
								</>
							) : (
								""
							)}
						</main>
					</div>
				</IconContext.Provider>
				{dialog.isLoading && (
					<Dialog
						//Update
						nameProduct={dialog.nameProduct}
						onDialog={areUSureSignOut}
						message={dialog.message}
					/>
				)}
			</div>
			<div className="loader-container" id="loaderMenu">
				<div className="loader"></div>
			</div>
		</>
	);
};

export default Menu;
